import { render, staticRenderFns } from "./WritingGuideDetail.vue?vue&type=template&id=f9822bec&scoped=true&"
import script from "./WritingGuideDetail.vue?vue&type=script&lang=js&"
export * from "./WritingGuideDetail.vue?vue&type=script&lang=js&"
import style0 from "./WritingGuideDetail.vue?vue&type=style&index=0&id=f9822bec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9822bec",
  null
  
)

export default component.exports